"use client";

import Script from "next/script";

export default function LemonSqueezyScript() {
  return (
    <Script
      src="https://app.lemonsqueezy.com/js/lemon.js"
      strategy="lazyOnload"
      onLoad={() => {
        // @ts-ignore
        if (window.createLemonSqueezy) {
          // @ts-ignore
          window.createLemonSqueezy();
        }
      }}
    />
  );
}
